<template>
  <div class="tbi-confirmation">
    <div class="faded-center">
      <div class="header">
        Thank you
      </div>
      <div class="content-header">
        Booking reference:
        <b>
          {{
            reserveResponse ? " " + reserveResponse.message : "ABCD123456789"
          }}
        </b>
      </div>
      <div class="content">
        Your request has been successfully submitted. <br />
        You should receive your confirmation email shortly.
      </div>
      <div class="upsell">
        <div class="upsell-card">
          <img src="@/assets/images/mom-child-airport.png" alt="" class="upsell-image"/>
          <h2>Book a flight</h2>
          <p>
            Search and filter to find the best flights for your requirements.
          </p>

          <a class="button-dark" href="https://flights.investectravel.com/"
            >Browse flights</a
          >
        </div>

        <div class="upsell-card card-border">
          <img src="@/assets/images/legs-off-bed.png" class="upsell-image" />
          <h2>Book a hotel</h2>
          <p>
            Browse thousands of hotels to see what suits you and your budget.
          </p>
          <a class="button-dark" href="https://hotels.secure.investec.com/"
            >Browse hotels</a
          >
        </div>

        <div class="upsell-card">
          <img src="@/assets/images/family-at-airport.jpeg" class="upsell-image"/>
          <h2>Buy travel insurance</h2>
          <p>
            Travel with peace of mind and ensure you are adequately covered for
            specified unforeseen events.
          </p>

          <a
            class="button-dark"
            href="https://www.investectravel.com/insurance/"
            >Visit Bryte</a
          >
        </div>
      </div>

      <div style="display: flex; width: 100%; justify-content: center; ">
        <div
          class="back-button"
          @click="$router.push({ name: 'search' })"
          style="cursor: pointer;"
        >
          Back to home page
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Api from "@/services/Api.service.js";

export default {
  name: "confirmation",
  data: function() {
    return {};
  },
  computed: {
    ...mapState([
      "reserveResponse",
      "searchParameters",
      "payerDetails",
      "driverDetails",
      "selectedCar",
      "oneway",
      "adminFee"
    ])
  },
  methods: {
    async sendConfirmationEmail() {
      try {
        const confirmationResult = await Api.confirm({
          email: this.payerDetails.email,
          bookingReference: this.reserveResponse.message,
          // bookingReference: this.reserveResponse.ReplyCCGroup.EFS_REFERENCE,
          seats: {
            numberOfBabySeats: this.selectedCar.numberOfBabySeats,
            numberOfChildSeats: this.selectedCar.numberOfChildSeats,
            numberOfBoosterSeats: this.selectedCar.numberOfBoosterSeats
          },
          oneway: this.oneway,
          onewayFees: this.selectedCar.onewayFee,
          adminFee: this.selectedCar.adminFee,
          type: "tbi"
        });
        console.log(confirmationResult);
      } catch (error) {
        console.log(error);
      }
    },
    fetchImagePath(group) {
      if (group == "K" || group == "KM" || group == "I") {
        return require(`@/assets/images/cars/${group}.jpg`);
      } else {
        return require(`@/assets/images/cars/${group}.png`);
      }
    },
    determineExtraDisplayName(extra) {
      let output = "Extra item";
      switch (extra) {
        case "namibiaBorder":
          output = "Cross Namibia border";
          break;
        case "eswatiniBorder":
          output = "Cross Eswatini border";
          break;
        case "botswanaBorder":
          output = "Cross Botswana border";
          break;
        case "windscreenWaiver":
          output = "Windscreen waiver";
          break;
        case "tyreAndWindscreenWaiver":
          output = "Tyre and Windscreen waiver";
          break;
        case "gps":
          output = "GPS rental";
          break;
        case "boosterSeat":
          output =
            this.selectedCar.numberOfBoosterSeats +
            " Booster seat(s) (3 years - 6 years)";
          break;
        case "childSeat":
          output =
            this.selectedCar.numberOfChildSeats +
            " Child seat(s) (6 months - 3 years)";
          break;
        case "babySeat":
          output =
            this.selectedCar.numberOfBabySeats + " Baby seat(s) (0 - 5 months)";
          break;
        case "bikeRack":
          output = "Bike rack";
          break;
        case "tyreWaiver":
          output = "Tyre waiver";
          break;
        case "additionalDriver":
          output = "2nd additional driver";
          break;
        case "driver":
          output = "Additional driver (free)";
          break;
        default:
          break;
      }
      return output;
    }
  },
  created() {
    this.sendConfirmationEmail();
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/settings.scss";

.back-button {
  color: white;
  white-space: nowrap;
  box-sizing: border-box;

  /* Auto layout */

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  gap: 8px;

  width: 200px;
  height: 48px;

  /* color/sys/light/bg/primary/strong/default

ref: navy.900
*/
  background: #30384a;
  /* color/sys/light/outline/primary/strong/default

ref: color.ref.navy.900
*/
  border: 2px solid #30384a;
  border-radius: 30px;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
}

.tbi-confirmation {
  background: rgba(230, 229, 225, 0.5);
  backdrop-filter: blur(20px);
  width: 100%;
  //height: 640px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 0.75em;
  padding-right: 0.75em;
}

.faded-center {
  max-width: 1180px;
  margin: 0.75em;
  background: #ffffff;
  mix-blend-mode: normal;
  padding: 40px 0px;
  display: flex;
  flex-direction: column;
  gap: 32px;

  .header {
    font-family: "Libre Caslon Text";
    font-style: normal;
    font-weight: 400;
    font-size: 40px;
    line-height: 48px;
    width: 100%;
    /* identical to box height, or 120% */

    display: flex;
    align-items: center;
    letter-spacing: -0.01em;
    text-align: center;
    justify-content: center;

    /* color/sys/light/text/lvl-1 */

    color: #30384a;
  }

  .content-header {
    width: 100%;

    font-family: "Inter";
    font-style: normal;
    font-weight: 500;
    font-size: 32px;
    line-height: 38px;
    /* or 119% */

    text-align: center;

    /* color/sys/light/text/lvl-3 */

    color: #5b626f;
  }
  .content {
    width: 100%;

    font-family: "Inter";
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    /* or 119% */

    text-align: center;

    /* color/sys/light/text/lvl-3 */

    color: #5b626f;
  }
  .button {
    width: 275px;
    height: 59px;
    /* left: 582px; */
    /* top: 408px; */
    border: 1px solid #02214d;
    box-sizing: border-box;
    border-radius: 2px;
  }
}

.red {
  color: red;
}

hr {
  margin-top: 0.75em;
  margin-bottom: 0.75em;
}

.details-divider {
  width: 100%;
  border-bottom: 2px dashed $grey;
}

h1 {
  font-weight: bold;
  font-size: 1.1em;
}

@media (min-width: 1100px) {
  h1 {
    font-size: 1.4em;
  }
  .upsell {
    flex-wrap: nowrap;
  }
  .card-border {
    border-left: 2px solid #ecece9;
    border-right: 2px solid #ecece9;
  }
}

@media (max-width: 781px) {
  .content {
    padding: 0px 32px;
  }
  .upsell {
    .upsell-card {
      .button-dark {
        padding-top: auto;
      }
      h2 {
        padding-top: 0px;
      }
    }
  }
}
</style>

<style lang="scss">
.message.is-primary .message-body {
  border-color: #00b6dd !important;
  color: #04333d;
}

.upsell {
  display: flex;
  flex-wrap: wrap;
  border-top: 2px solid #ecece9;
  padding-top: 30px;
  border-bottom: 2px solid #ecece9;
}

.upsell-card {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  padding: 0 40px;
  padding-bottom: 30px;
  text-align: center;

  .button-dark {
    margin-top: auto;
  }

  h2 {
    font-family: "Libre Caslon Text", serif;
    font-size: 200%;
    padding-top: 20px;
    padding-bottom: 15px;
  }
  p {
    font-family: "Inter", serif;
    padding-bottom: 20px;
  }
}

.button-dark {
  color: white !important;
  font-family: "Inter", sans-serif;
  white-space: nowrap;
  box-sizing: border-box;

  /* Auto layout */

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  gap: 8px;

  width: 182px;
  height: 40px;

  background: #30384a;
  border: 2px solid #30384a;
  border-radius: 20px;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.upsell-image {
  height: 170px;
  width: 100%;
  max-width: 220px;
  object-fit: cover;
  border-radius: 8px;
  margin-bottom: 20px;
}
</style>
